'use client'
import { ResponsiveValue } from '@chakra-ui/react'
import { Flex, Text } from '@core/ui-elements'
import { Property } from 'csstype'
import { useEffect, useState } from 'react'

import { AmountInput } from '../amount-input'

export interface IAmountInputWithName {
  label: string
  setInput: (amount: number) => void
  labelPosition?: 'top' | 'left' | 'bottom' | 'right'
  show2plus?: boolean
  minInput?: number
  alwaysDisplayRemoveButton?: boolean
  enableInput?: boolean
  maxValue?: number
  setIsInvalidValue?: (value: boolean) => void
  onSubmit?: () => void
}

export const AmountInputWithName = ({
  label,
  setInput,
  labelPosition = 'left',
  show2plus = true,
  minInput = 0,
  alwaysDisplayRemoveButton,
  enableInput,
  maxValue,
  setIsInvalidValue,
  onSubmit,
}: IAmountInputWithName) => {
  const [amount, setAmount] = useState(minInput)

  useEffect(() => {
    setInput(amount)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount])

  const labelDirection: ResponsiveValue<Property.FlexDirection> = {
    top: 'column',
    left: 'row',
    bottom: 'column-reverse',
    right: 'row-reverse',
  }

  return (
    <Flex
      alignItems="center"
      alignSelf="stretch"
      borderRadius="0.5rem"
      flexDirection={labelDirection[labelPosition]}
      gap="0.25rem"
      justifyContent="space-between"
      padding="0.25rem 0.5rem"
      width={'100%'}
    >
      <Text fontWeight="600">{label}</Text>
      <AmountInput
        alwaysDisplayRemoveButton={alwaysDisplayRemoveButton}
        enableInput={enableInput}
        maxValue={maxValue}
        minValue={minInput}
        selectAll={false}
        setIsInvalidValue={setIsInvalidValue}
        setValue={setAmount}
        show2plus={show2plus}
        size="md"
        value={amount}
        onSubmit={onSubmit}
      />
    </Flex>
  )
}
